var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#github_svg__a)",
    d: "M6.316 6.176c-.25-.638-.24-1.367-.129-2.034a6.8 6.8 0 0 1 2.12 1.07c.279.214.646.283.989.18A9.3 9.3 0 0 1 12 5c.961 0 1.873.14 2.702.391.343.104.71.034.988-.18a6.8 6.8 0 0 1 2.12-1.07c.11.667.12 1.396-.128 2.033-.15.384-.075.826.207 1.14C18.614 8.117 19 9.04 19 10c0 2.114-1.969 4.187-5.133 4.818-.793.158-1.102 1.155-.495 1.726.388.366.629.882.629 1.456v3a1 1 0 0 0 2 0v-3c0-.57-.12-1.112-.335-1.603 3.018-1.047 5.335-3.404 5.335-6.397 0-1.347-.485-2.585-1.288-3.622.21-.82.192-1.646.112-2.28-.072-.568-.17-1.312-.571-1.756-.595-.659-1.58-.271-2.28-.032a9 9 0 0 0-2.125 1.046A11.4 11.4 0 0 0 12.001 3c-.994 0-1.954.125-2.852.356a9 9 0 0 0-2.125-1.045c-.7-.24-1.686-.628-2.28.031-.408.452-.494 1.137-.567 1.719l-.005.038c-.08.635-.098 1.462.113 2.283C3.484 7.418 3.001 8.654 3.001 10c0 2.992 2.317 5.35 5.334 6.397A4 4 0 0 0 8 17.98l-.168.034c-.717.099-1.176.01-1.489-.122-.76-.322-1.151-1.133-1.63-1.753-.298-.385-.731-.866-1.397-1.088a1 1 0 0 0-.633 1.898c.56.186.945 1.142 1.298 1.566.373.448.87.916 1.581 1.218.682.29 1.482.393 2.438.276V21a1 1 0 0 0 2 0v-3c0-.574.24-1.09.629-1.456.606-.572.297-1.568-.496-1.726C6.97 14.187 5.001 12.114 5.001 10c0-.958.385-1.881 1.108-2.684.282-.314.357-.756.207-1.14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "github_svg__a",
    x1: 19.315,
    x2: -19.147,
    y1: 2.53,
    y2: 16.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgGithub;